import styled from 'styled-components'
import { Input } from 'pcln-design-system'

const EmailInput = styled(Input)`
  border-radius: 2px;
  display: inline;
  height: 40px;
  width: 308px;
`

EmailInput.displayName = 'EmailInput'

export default EmailInput
